import { render, staticRenderFns } from "./rxDetails.vue?vue&type=template&id=38fcb1c5"
import script from "./rxDetails.vue?vue&type=script&lang=js"
export * from "./rxDetails.vue?vue&type=script&lang=js"
import style0 from "./rxDetails.vue?vue&type=style&index=0&id=38fcb1c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports